import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "adaa-send-confirmation-modal",
  imports: [TranslatePipe],
  templateUrl: "./send-confirmation-modal.html",
  styleUrl: "./send-confirmation-modal.scss",
})
export class SendConfirmationModalComponent {
  @Input() header: string;
  @Input() title: string;
  @Input() subTitle: string = "common.form.label.are_you_sure";
  @Input() yesLabel: string = "common.form.button.confirm";
  @Input() noLabel: string = "common.form.button.cancel";
  @Input() items: string[];

  modal: NgbActiveModal = inject(NgbActiveModal);
}
